<template>
  <div v-if="itemOrMenu.meta && itemOrMenu.meta.levelHidden">
    <template v-for="route in itemOrMenu.children">
      <bd-menu :key="route.path" :item="route" />
    </template>
  </div>
  <el-submenu
    v-else
    ref="subMenu"
    :index="itemOrMenu.path"
    :popper-append-to-body="false"
  >
    <template slot="title">
      <svg-icon
        v-if="itemOrMenu.meta && itemOrMenu.meta.icon"
        :icon-class="itemOrMenu.meta.icon"
        :is-custom-svg="itemOrMenu.meta.isCustomSvg"
        :title="itemOrMenu.meta.title"
      />
      <span :title="itemOrMenu.meta.title">
        {{ itemOrMenu.meta.title }}
      </span>
    </template>
    <slot />
  </el-submenu>
</template>

<script>

export default {
  name: 'VabSubmenu',
  props: {
    itemOrMenu: {
      type: Object,
      default () {
        return null
      }
    }
  },
  methods: {

  }
}
</script>
